var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[_c('div',{attrs:{"id":"main_top"}},[_c('MainTop')],1),_c('div',{attrs:{"id":"main_body"}},[_c('el-row',{attrs:{"id":"main_sidebar_conts"}},[_c('router-view')],1),_c('div',{attrs:{"id":"main_bottom"}},[_c('MainBottom')],1),_c('el-backtop',{attrs:{"target":"#main_body","right":20}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }